import React from 'react';
import numeral from "numeral";
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default class CartTotal extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { products = {}, order } = this.props;
    
    // console.log('CartTotal props:', this.props.products);
    
    return (
      <div className="CartTotal">
        <div className="card">
          {Object.keys(products).length ? this.renderProducts(products) : <div className="empty-cart">{I18n.t('your_cart_is_empty')}</div>}
          {Object.keys(products).length ? 
            <div className="cart-totals">
              {Object.keys(products).length ? this.renderSubtotal(order, products) : null}
              {order && order.taxes_amount  ? this.renderTaxAmount(order.taxes_amount) : null}
              {order && order.total_amount  ? this.rendderTotalAmount(order.total_amount) : null}
            </div>
          : null}
          <LoadingSpinner show={this.props.loading} />
        </div>
      </div>
    )
  }

  renderSubtotal(order, products) {
    if (order && order.subtotal_amount) {
      var subtotal = order.subtotal_amount;
    } else {
      var subtotal = Object.values(products).reduce((subtotal, products) => {
        return subtotal + products.reduce((product_subtotal, product) => {
          return product_subtotal + product.amount;
        }, 0);
      }, 0);
    }

    return (
      <div className="cart-subtotal">
        <div className="cart-subtotal-label">{I18n.t('subtotal')}</div>
        <div className="cart-subtotal-amount">{this.renderAmount(subtotal)}</div>
      </div>
    )
  }

  renderTaxAmount(amount) {
    return (
      <div className="cart-subtotal">
        <div className="cart-subtotal-label">{I18n.t('tax')}</div>
        <div className="cart-subtotal-amount">{this.renderAmount(amount)}</div>
      </div>
    )
  }

  rendderTotalAmount(amount) {
    return (
      <div className="cart-subtotal cart-total">
        <div className="cart-subtotal-label">{I18n.t('total')}</div>
        <div className="cart-subtotal-amount">{this.renderAmount(amount)}</div>
      </div>
    )
  }

  renderProducts(products) {
    const { allowEdit = true } = this.props;
    const rendered_products = Object.values(products).map((products) => {
      const product = products[0];

      return(
        <div key={product.id} className="cart-product">
          <div className="cart-product-details">
            <div className="cart-product-name">{product.name}</div>
            <div className="cart-product-amounts">
              <div className="cart-product-amount">{this.renderAmount(product.amount)} {!allowEdit ? <span>&times; {products.length}</span> : null}</div>
              {allowEdit ? this.renderQuantityInput(products, product) : null}
              {allowEdit ? <span className="fa fa-trash" onClick={() => this.props.onRemoveProduct(product)} /> : null}
              <div className="cart-product-amount">{this.renderAmount(product.amount * products.length)}</div>
            </div>
          </div>
        </div>
      );
    });

    return <div className="cart-products">{rendered_products}</div>;
  }

  renderAmount(amount) {
    return <span>{this.props.currency.symbol}{numeral(amount / 100).format('0,0.00')}</span>
  }

  renderQuantityInput(products, product) {
    return <input type="number" className="form-control" min="1" max="999" value={products.length} onChange={(e) => this.props.onChangeProductQuantity(product, e.target.value)} />
  }

}